<template>
    <div id="profile-page">
        <!-- PROFILE HEADER -->

        <div class="profile-header">
            <div class="relative">
                <div class="cover-container rounded-t-lg">
                    <img :src="user_info.cover_img" alt="user-profile-cover" class="responsive block" />
                </div>
            </div>
        </div>
        <div class="vx-row mt-5">
            <vs-col vs-offset="4" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                <vs-input
                    type="text"
                    icon-pack="feather"
                    icon="icon-search"
                    label-placeholder="환자명 입력"
                    v-model="username"
                    class="w-full mb-4 pl-2 mt-2"
                    v-on:keyup.enter="userSearch"
                    size="large"
                />

                <vs-button class="w-2 ml-2" @click="userSearch" ref="username" icon-pack="feather" icon="icon-search" size="large"></vs-button>
            </vs-col>

            <div class="vx-col w-full text-center">
                <div v-if="usernameCheck == true" class="text-danger mb-4">{{ userCheckMsg }}</div>
            </div>
        </div>
        <div class="vx-row ml-5">
            <a href="../patient/list"> <vs-button color="primary" type="border">환자리스트로 이동</vs-button></a>
        </div>
        <!-- COL AREA -->
        <div class="vx-row m-2">
            <div class="vx-col md:w-1/3 w-full">
                <vx-card title="👥 환자리스트">
                    <p>해당 환자를 클릭하시면 오른쪽에 식사관리를 할 수 있습니다.</p>

                    <vs-table v-model="selected" @selected="handleSelected" :data="lists" style="height:400px; overflow:auto;">
                        <template slot="thead">
                            <vs-th class="table_header">병실</vs-th>
                            <vs-th class="table_header">이름</vs-th>
                            <vs-th class="table_header">성별</vs-th>
                            <vs-th class="table_header">나이</vs-th>
                        </template>

                        <template slot-scope="{ data }">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td :data="tr.MEDICAL_ROOM_NM"> {{ tr.MEDICAL_ROOM_NM }}({{ tr.MEDICAL_ROOM_NUMBER_NM }}) </vs-td>
                                <vs-td :data="tr.PATIENT_USERNAME">
                                    {{ tr.PATIENT_USERNAME }}
                                </vs-td>
                                <vs-td :data="tr.PATIENT_GENDER_CONVERT">
                                    {{ tr.PATIENT_GENDER_CONVERT }}
                                </vs-td>
                                <vs-td :data="tr.PATIENT_AGE">
                                    {{ tr.PATIENT_AGE }}
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                    <br />
                </vx-card>
            </div>
            <div class="vx-col w-full md:w-2/3">
                <vx-card title="🍱 세부 식사관리">
                    <h5 class="rounded-lg m-3" @input="mealData()">
                        <template v-if="selected.MEDICAL_ROOM_NM != undefined"
                            >👤<b>{{ selected.PATIENT_USERNAME }}</b
                            >({{ selected.MEDICAL_ROOM_NM }} - {{ selected.MEDICAL_ROOM_NUMBER_NM }})</template
                        >
                    </h5>
                    <input type="hidden" v-model="today" />
                    <input type="hidden" v-model="tomorrow" />
                    <input type="hidden" v-model="tomorrow_next" />

                    <!-- <vs-row class="mb-6">
                        <vs-col vs-type="flex" vs-justify="" vs-align="" vs-w="10">
                            <vs-button color="success" type="border" class="mr-12" @click="excelDownload">환자 식단표 출력</vs-button>
                        </vs-col>
                    </vs-row> -->

                    <vs-table :data="lists" :noDataText="'데이터가 존재하지 않습니다.'">
                        <template slot="thead" search :data="lists">
                            <vs-th class="table_header">날짜</vs-th>
                            <vs-th class="table_header">아침</vs-th>
                            <vs-th class="table_header">점심</vs-th>
                            <vs-th class="table_header">저녁</vs-th>
                        </template>
                        <template>
                            <vs-tr>
                                <vs-td>{{ new Date() | moment('YYYY-MM-DD (ddd)') }} </vs-td>
                                <vs-td>
                                    <div class="demo-alignment">
                                        <vs-select autocomplete class="selectExample" v-model="select11">
                                            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in options" />
                                        </vs-select>
                                    </div>
                                    <div class="demo-alignment">
                                        <vs-textarea label="메모내용 입력" v-model="memo11" class="w-full mb-4  mt-5" size="large" />
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <div class="demo-alignment">
                                        <vs-select autocomplete class="selectExample" v-model="select12">
                                            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in options" />
                                        </vs-select>
                                    </div>
                                    <div class="demo-alignment">
                                        <vs-textarea label="메모내용 입력" v-model="memo12" class="w-full mb-4  mt-5" size="large" />
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <div class="demo-alignment">
                                        <vs-select autocomplete class="selectExample" v-model="select13">
                                            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in options" />
                                        </vs-select>
                                    </div>
                                    <div class="demo-alignment">
                                        <vs-textarea label="메모내용 입력" v-model="memo13" class="w-full mb-4  mt-5" size="large" />
                                    </div>
                                </vs-td>
                            </vs-tr>
                            <vs-tr>
                                <vs-td>{{
                                    $moment(new Date())
                                        .add(1, 'days')
                                        .format('YYYY-MM-DD (ddd)')
                                }}</vs-td>
                                <vs-td>
                                    <div class="demo-alignment">
                                        <vs-select autocomplete class="selectExample" v-model="select21">
                                            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in options" />
                                        </vs-select>
                                    </div>
                                    <div class="demo-alignment">
                                        <vs-textarea label="메모내용 입력" v-model="memo21" class="w-full mb-4  mt-5" size="large" />
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <div class="demo-alignment">
                                        <vs-select autocomplete class="selectExample" v-model="select22">
                                            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in options" />
                                        </vs-select>
                                    </div>
                                    <div class="demo-alignment">
                                        <vs-textarea label="메모내용 입력" v-model="memo22" class="w-full mb-4  mt-5" size="large" />
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <div class="demo-alignment">
                                        <vs-select autocomplete class="selectExample" v-model="select23">
                                            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in options" />
                                        </vs-select>
                                    </div>
                                    <div class="demo-alignment">
                                        <vs-textarea label="메모내용 입력" v-model="memo23" class="w-full mb-4  mt-5" size="large" />
                                    </div>
                                </vs-td>
                            </vs-tr>
                            <vs-tr>
                                <vs-td>{{
                                    $moment(new Date())
                                        .add(2, 'days')
                                        .format('YYYY-MM-DD (ddd)')
                                }}</vs-td>
                                <vs-td>
                                    <div class="demo-alignment">
                                        <vs-select autocomplete class="selectExample" v-model="select31">
                                            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in options" />
                                        </vs-select>
                                    </div>
                                    <div class="demo-alignment">
                                        <vs-textarea label="메모내용 입력" v-model="memo31" class="w-full mb-4  mt-5" size="large" />
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <div class="demo-alignment">
                                        <vs-select autocomplete class="selectExample" v-model="select32">
                                            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in options" />
                                        </vs-select>
                                    </div>
                                    <div class="demo-alignment">
                                        <vs-textarea label="메모내용 입력" v-model="memo32" class="w-full mb-4  mt-5" size="large" />
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <div class="demo-alignment">
                                        <vs-select autocomplete class="selectExample" v-model="select33">
                                            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in options" />
                                        </vs-select>
                                    </div>
                                    <div class="demo-alignment">
                                        <vs-textarea label="메모내용 입력" v-model="memo33" class="w-full mb-4  mt-5" size="large" />
                                    </div>
                                </vs-td>
                            </vs-tr>
                            <vs-tr>
                                <vs-td colspan="4">
                                    <vs-button class="shadow-md w-full lg:mt-0 mt-4" @click="mealSave">저장</vs-button>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
import axiosClass from '@/../util/axiosClass';
import XLSX from 'xlsx';
export default {
    components: {},
    data() {
        return {
            username: '',
            usernameCheck: false,
            userCheckMsg: '',
            selected: [],
            search_username: '',
            lists: [],
            patient_name: '',
            mor_meal: '',
            lunch_meal: '',
            dinner_meal: '',
            select11: '',
            select12: '',
            select13: '',
            select21: '',
            select22: '',
            select23: '',
            select31: '',
            select32: '',
            select33: '',
            memo11: '',
            memo12: '',
            memo13: '',
            memo21: '',
            memo22: '',
            memo23: '',
            memo31: '',
            memo32: '',
            memo33: '',
            options: [
                { text: '일반식', value: 1 },
                { text: '죽', value: 2 },
                { text: '취소', value: 9 },
            ],
            today: this.$moment(new Date()).format('YYYY-MM-DD'),
            tomorrow: this.$moment(new Date())
                .add(1, 'days')
                .format('YYYY-MM-DD'),
            tomorrow_next: this.$moment(new Date())
                .add(2, 'days')
                .format('YYYY-MM-DD'),
            user_info: {
                cover_img: require('@/assets/images/profile/user-uploads/food.png'),
            },
            excelData: [],
            fileName: '',
            sheetName: 'data',
        };
    },
    methods: {
        /** 식사관리 - 환자검색 */
        async userSearch() {
            this.usernameCheck = false;

            if (this.username == false) {
                this.usernameCheck = true;
                this.userCheckMsg = '검색할 이름을 입력해주세요.';
                return;
            }
            this.userList();
        },
        handleSelected(tr) {
            this.$vs.notify({
                title: `${tr.PATIENT_USERNAME} 선택`,
                text: `병동: ${tr.MEDICAL_ROOM_NM}`,
            });
            this.mealData();
        },
        async userList() {
            try {
                let params = {
                    search_name: this.username,
                };
                console.log('params:', params);
                const { data } = await axiosClass.get('/api/patient/search_patientList', params, true);
                console.log(data);
                this.lists = data.data;
            } catch (e) {
                console.log(e.response.data);
            }
        },
        async mealData() {
            let params = {
                patient_uid: this.selected.PATIENT_UID,
                today: this.today,
                tomorrow: this.tomorrow,
                tomorrow_next: this.tomorrow_next,
            };
            console.log(params);
            const { data } = await axiosClass.get('/api/patient/patientMealInfo', params, true);
            // console.log(data.data[0].CODE_MEAL_1);
            this.select11 = data.data[0].CODE_MEAL_1;
            this.select12 = data.data[0].CODE_MEAL_2;
            this.select13 = data.data[0].CODE_MEAL_3;
            this.select21 = data.data[1].CODE_MEAL_1;
            this.select22 = data.data[1].CODE_MEAL_2;
            this.select23 = data.data[1].CODE_MEAL_3;
            this.select31 = data.data[2].CODE_MEAL_1;
            this.select32 = data.data[2].CODE_MEAL_2;
            this.select33 = data.data[2].CODE_MEAL_3;
            this.memo11 = data.data[0].MEMO_1;
            this.memo12 = data.data[0].MEMO_2;
            this.memo13 = data.data[0].MEMO_3;
            this.memo21 = data.data[1].MEMO_1;
            this.memo22 = data.data[1].MEMO_2;
            this.memo23 = data.data[1].MEMO_3;
            this.memo31 = data.data[2].MEMO_1;
            this.memo32 = data.data[2].MEMO_2;
            this.memo33 = data.data[2].MEMO_3;
        },
        async mealSave() {
            let params = {
                patient_uid: this.selected.PATIENT_UID,
                today: this.today,
                tomorrow: this.tomorrow,
                tomorrow_next: this.tomorrow_next,
                select11: this.select11,
                select12: this.select12,
                select13: this.select13,
                select21: this.select21,
                select22: this.select22,
                select23: this.select23,
                select31: this.select31,
                select32: this.select32,
                select33: this.select33,
                memo11: this.memo11,
                memo12: this.memo12,
                memo13: this.memo13,
                memo21: this.memo21,
                memo22: this.memo22,
                memo23: this.memo23,
                memo31: this.memo31,
                memo32: this.memo32,
                memo33: this.memo33,
                memo11: this.memo11,
                memo12: this.memo12,
                memo13: this.memo13,
                memo21: this.memo21,
                memo22: this.memo22,
                memo23: this.memo23,
                memo31: this.memo31,
                memo32: this.memo32,
                memo33: this.memo33,
                memo11: this.memo11,
                memo12: this.memo12,
                memo13: this.memo13,
                memo21: this.memo21,
                memo22: this.memo22,
                memo23: this.memo23,
                memo31: this.memo31,
                memo32: this.memo32,
                memo33: this.memo33,
            };

            console.log(params);
            if (this.selected.PATIENT_UID == '' || this.selected.PATIENT_UID == undefined) {
                this.$vs.notify({
                    title: '확인',
                    text: '왼쪽에서 해당 환자를 선택하시고 저장을 눌러주세요.',
                    color: 'danger',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-check',
                });
                return;
            }
            const { data } = await axiosClass.post('/api/patient/patientMealSave', params, true);
            console.log(data);
            this.$vs.notify({
                title: `식단저장`,
                text: `식사관리가 저장되었습니다.`,
            });
            this.mealData();
            return;
        },
        async excelDownload() {
            let jsonData = {};
            let params = {
                today: this.today,
            };

            const { data } = await axiosClass.get('/api/patient/patientMealExcel', params, true);
            console.log('ok' + data);
            if (data.success == false) {
                this.$vs.notify({
                    title: 'ERROR',
                    text: data.message,
                    color: 'danger',
                    position: 'right',
                    iconPack: 'feather',
                    icon: 'icon-check',
                });
            } else {
                this.now = this.$moment().format('YYYYMMDDHHmmss');
                this.excelData = data.data;
                this.fileName = this.now + '_환자식단';
            }
            this.onexport();
        },

        onexport() {
            var excelDataWS = XLSX.utils.json_to_sheet(this.excelData);
            var wb = XLSX.utils.book_new(); // make Workbook of Excel
            XLSX.utils.book_append_sheet(wb, excelDataWS, this.sheetName);
            // export Excel file
            XLSX.writeFile(wb, this.fileName + '.xlsx');
        },
    },
    created() {
        this.userList();
    },
};
</script>

<style lang="scss">
@import '@/assets/scss/vuexy/pages/profile.scss';
</style>
